<template>
  <div>
    <b-form class="hc-modern-form" @submit.stop.prevent="submitData">
      <section class="hc-form-section">
        <h5 class="hc-form-section-title">Periode & Identitas Kupon</h5>
      <div class="row">
        <!-- Date Picker -->
        <div class="col-lg-6 col-12">
          <b-form-group
            id="input-group-start-date"
            label="Dari Tgl:"
            label-for="input-start-date"
          >
            <b-input-group class="hc-date-input">
              <b-input-group-prepend>
                <b-form-datepicker
                  locale="id"
                  placeholder="Tanggal Mulai"
                  id="start-date-picker"
                  v-model="form.start_date"
                  button-only
                  aria-controls="example-input"
                ></b-form-datepicker>
              </b-input-group-prepend>
              <b-form-input
                id="input-start-date"
                v-model="form.start_date"
                type="text"
                placeholder="YYYY-MM-DD"
                @input="formaterDate"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          <small class="text-danger">{{ error.start_date }}</small>
        </div>

        <!-- Date Picker -->
        <div class="col-lg-6 col-12">
          <b-form-group
            id="input-group-end-date"
            label="Tanggal Selesai:"
            label-for="input-date-end"
          >
            <b-input-group class="hc-date-input">
              <b-input-group-prepend>
                <b-form-datepicker
                  locale="id"
                  placeholder="Tanggal"
                  id="end-date-picker"
                  v-model="form.end_date"
                  button-only
                  aria-controls="example-input"
                ></b-form-datepicker>
              </b-input-group-prepend>
              <b-form-input
                id="input-date-end"
                v-model="form.end_date"
                type="text"
                placeholder="YYYY-MM-DD"
                @input="formaterDateEnd"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
          <small class="text-danger">{{ error.end_date }}</small>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <b-form-group label="Minimum Transaksi:" label-for="coupon-minimum-purchase">
            <b-input-group prepend="Rp"><b-form-input id="coupon-minimum-purchase" v-model="formatedMinimumPurchase" inputmode="numeric" placeholder="0 (tanpa minimum)"></b-form-input></b-input-group>
            <small class="text-muted">Kupon hanya berlaku jika subtotal mencapai nilai ini.</small>
            <small class="text-danger d-block">{{ error.minimum_purchase }}</small>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Kuota Total:" label-for="coupon-usage-limit">
            <b-form-input id="coupon-usage-limit" v-model.number="form.usage_limit" type="number" min="1" placeholder="Tidak terbatas"></b-form-input>
            <small class="text-muted">Jumlah maksimal pemakaian oleh semua pasien.</small>
            <small class="text-danger d-block">{{ error.usage_limit }}</small>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group label="Batas per Pasien:" label-for="coupon-patient-limit">
            <b-form-input id="coupon-patient-limit" v-model.number="form.per_patient_limit" type="number" min="1" placeholder="Tidak terbatas"></b-form-input>
            <small class="text-muted">Cegah satu pasien memakai kupon berulang kali.</small>
            <small class="text-danger d-block">{{ error.per_patient_limit }}</small>
          </b-form-group>
        </div>
      </div>

      <div class="hc-promotion-switches">
        <b-form-checkbox v-model="form.is_active" :value="true" :unchecked-value="false" switch>
          <strong>Program aktif</strong><small>Kupon dapat digunakan selama periode berlaku.</small>
        </b-form-checkbox>
        <b-form-checkbox v-model="form.is_stackable" :value="true" :unchecked-value="false" switch>
          <strong>Boleh digabung promo</strong><small>Izinkan kupon dipakai bersama diskon item.</small>
        </b-form-checkbox>
      </div>

      <!-- Name input -->
      <b-form-group id="input-group-name" label="Kode Kupon:" label-for="input-name">
        <b-form-input
          id="input-name"
          v-model="form.name"
          placeholder="Contoh: SEHAT20"
        ></b-form-input>
        <small class="text-danger">{{ error.name }}</small>
      </b-form-group>
      </section>

      <section class="hc-form-section">
        <h5 class="hc-form-section-title">Aturan Potongan</h5>
      <div class="row">
        <div class="col-md-4">
          <!-- Input Jenis -->
          <b-form-group
            id="input-group-status"
            label="Jenis Potongan:"
            label-for="input-status"
          >
            <b-form-select
              id="input-status"
              v-model="form.is_percent"
              :options="type"
              @change="setType(form.is_percent)"
            ></b-form-select>
            <small class="text-danger">{{ error.is_percent }}</small>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group
            id="input-group-amount"
            label="Besar Potongan:"
            label-for="input-amount"
          >
            <b-input-group :prepend="type_value" class="">
              <b-form-input
                id="input-amount"
                v-model="formatedAmount"
                inputmode="numeric"
                placeholder="Besar Potongan"
              ></b-form-input>
            </b-input-group>
            <small class="text-danger">{{ error.amount }}</small>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group id="input-group-max-amount">
            <label for="input-max-amount"
              >Maksimal Potongan : <em class="text-muted">opsional</em></label
            >
            <b-input-group prepend="Rp" class="">
              <b-form-input
                id="input-max-amount"
                v-model="formatedMaxAmount"
                inputmode="numeric"
                placeholder="Maksimal Potongan"
                :disabled="form.is_percent == 0"
              ></b-form-input>
            </b-input-group>
            <small class="text-danger">{{ error.max_amount }}</small>
          </b-form-group>
        </div>
      </div>

      <!-- Description input -->
      <b-form-group id="input-group-description">
        <label for="input-description"
          >Deskripsi : <em class="text-muted">opsional</em></label
        >
        <b-form-textarea
          id="input-description"
          v-model="form.description"
          placeholder="Deksripsi"
          rows="4"
          max-rows="8"
        ></b-form-textarea>
        <small class="text-danger">{{ error.description }}</small>
      </b-form-group>
      </section>

      <section class="hc-form-section">
        <h5 class="hc-form-section-title">Target & Prioritas Otomatis</h5>
        <div class="row"><div class="col-md-4"><b-form-group label="Prioritas"><b-form-input v-model.number="form.priority" type="number" min="0"></b-form-input></b-form-group></div><div class="col-md-4"><b-form-group label="Jam mulai"><b-form-input v-model="form.valid_start_time" type="time"></b-form-input></b-form-group></div><div class="col-md-4"><b-form-group label="Jam selesai"><b-form-input v-model="form.valid_end_time" type="time"></b-form-input></b-form-group></div></div>
        <b-form-group label="Kanal transaksi"><b-form-checkbox-group v-model="form.service_channels" :options="channelOptions"></b-form-checkbox-group><small class="text-muted">Kosong berarti semua kanal.</small></b-form-group>
        <b-form-group label="Cabang/tenant sasaran"><b-form-tags v-model="form.branch_ids" separator=" ,;" placeholder="Ketik kode cabang lalu Enter"></b-form-tags><small class="text-muted">Kosong berarti berlaku untuk seluruh cabang/tenant.</small></b-form-group>
        <b-form-group label="Segmen pasien"><b-form-checkbox-group v-model="form.patient_segments" :options="segmentOptions"></b-form-checkbox-group></b-form-group>
        <b-form-group label="Hari berlaku"><b-form-checkbox-group v-model="form.days_of_week" :options="dayOptions"></b-form-checkbox-group></b-form-group>
        <b-form-group label="Metode pembayaran"><div v-if="loadingPaymentMethods" class="text-muted py-2"><span class="spinner-border spinner-border-sm mr-2"></span>Memuat metode pembayaran...</div><b-form-checkbox-group v-else v-model="form.payment_method_ids" :options="paymentMethodOptions"></b-form-checkbox-group><small class="text-muted">Kosong berarti berlaku untuk semua metode pembayaran.</small></b-form-group>
      </section>

      <!-- Submit & Cancel button -->
      <div class="hc-form-actions">
      <b-button
        type="button"
        variant="light"
        @click="$router.push('/masters/coupons/list')"
      >
        Batal
      </b-button>
      <b-button type="submit" variant="primary">
        <i class="fas fa-save mr-2"></i>Simpan Kupon
      </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";

export default {
  props: {
    form: Object,
    route: String,
  },

  data() {
    return {
      // type coupon
      type: [
        {
          text: "Nominal (Rp)",
          value: 0,
        },
        {
          text: "Persen (%)",
          value: 1,
        },
      ],
      type_value: "Rp",
      channelOptions: [{text:"Rawat jalan & kasir klinik",value:"clinic"},{text:"Apotek",value:"pharmacy"},{text:"Rawat inap",value:"inpatient"},{text:"Home Care",value:"home_care"}],
      loadingPaymentMethods: false,
      paymentMethodOptions: [],
      segmentOptions: [{text:"Pasien baru",value:"new"},{text:"Pasien lama",value:"returning"}],
      dayOptions: [{text:"Sen",value:1},{text:"Sel",value:2},{text:"Rab",value:3},{text:"Kam",value:4},{text:"Jum",value:5},{text:"Sab",value:6},{text:"Min",value:7}],
      // Error
      error: {
        name: "",
        is_percent: "",
        start_date: "",
        end_date: "",
        amount: "",
        max_amount: "",
        minimum_purchase: "",
        usage_limit: "",
        per_patient_limit: "",
        description: "",
      },
    };
  },

  computed: {
    formatedAmount: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.amount = newValue.toLocaleString("id-ID");
        } else {
          this.form.amount = 0;
        }
      },
      get() {
        return this.form.amount;
      },
    },
    formatedMaxAmount: {
      set(newValue) {
        newValue = parseInt(newValue.replace(/\D/g, ""), 10);
        if (!Number.isNaN(newValue)) {
          this.form.max_amount = newValue.toLocaleString("id-ID");
        } else {
          this.form.max_amount = 0;
        }
      },
      get() {
        return this.form.max_amount;
      },
    },
    formatedMinimumPurchase: {
      set(newValue) {
        const parsed = parseInt(String(newValue).replace(/\D/g, ""), 10);
        this.form.minimum_purchase = Number.isNaN(parsed) ? 0 : parsed.toLocaleString("id-ID");
      },
      get() { return this.form.minimum_purchase; },
    },
  },

  methods: {
    submitData() {
      if (this.form.is_percent == 1) {
        if (Number(String(this.form.amount).replace(/\D/g, "")) > 100) {
          Swal.fire(
            "Perhatian",
            "Besaran Potongan Kupon tidak boleh lebih dari 100%",
            "warning"
          );
        } else {
          this.formOnsubmit();
        }
      } else {
        this.formOnsubmit();
      }
    },

    async formOnsubmit() {
      let response = await module.submit(this.form, this.route);
      // Check Response
      if (response.state == "error") {
        // Validation Error
        this.error = validation.setValidationError(
          this.error,
          response.error.errors
        );
      } else {
        // Success
        Swal.fire(response.success.title, response.success.message, "success");
        this.$router.push("/masters/coupons");
      }
    },

    setType(data) {
      if (data == 0) {
        this.type_value = "Rp";
        this.form.max_amount = 0;
      } else {
        this.type_value = "%";
      }
    },
    formaterDate(val) {
      if (val.length == 4) {
        this.form.start_date = this.form.start_date + "-";
      }
      if (val.length == 7) {
        this.form.start_date = this.form.start_date + "-";
      }
    },

    formaterDateEnd(val) {
      if (val.length == 4) {
        this.form.end_date = this.form.end_date + "-";
      }
      if (val.length == 7) {
        this.form.end_date = this.form.end_date + "-";
      }
    },
  },

  async mounted() {
    this.loadingPaymentMethods = true;
    const methods = await module.setSelectOption("payment-methods");
    this.paymentMethodOptions = methods.state === "success" ? methods.data : [];
    this.loadingPaymentMethods = false;
    if (this.form.is_percent == 1) {
      this.type_value = "%"
      this.form.max_amount = parseInt(this.form.max_amount).toLocaleString('id-ID')
    }else{
      this.type_value = "Rp"
    }
    if (this.form.minimum_purchase) this.form.minimum_purchase = parseInt(this.form.minimum_purchase).toLocaleString('id-ID')
  }
};
</script>

<style scoped>
.hc-promotion-switches { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin: 4px 0 18px; padding: 14px; border: 1px solid #e4eaf1; border-radius: 12px; background: #f8fafc; }
.hc-promotion-switches small { display: block; margin-left: 24px; color: #7b8797; font-size: 10px; }
@media (max-width: 767px) { .hc-promotion-switches { grid-template-columns: 1fr; } }
</style>
